module.exports = __webpack_public_path__ + "static/media/DGAC_Dashboardfeatures_mobile.66f5ec5e.png";